<template  >
    <div
        class="cubeSpace d-flex flex-wrap justify-content-center align-items-center py-5 px-lg-3 px-4 px-lg-0 my-3 my-lg-0">
        <div
            class="col-12 col-lg-5 d-flex flex-wrap justify-content-center align-items-center align-content-center overflow-hidden">
            <div
                class="col-lg-10 col-xl-12 col-12 d-flex justify-content-lg-end justify-content-center text-center align-items-center flex-wrap px-lg-0 px-3 my-3 my-lg-0">
                <img :src="a20" class="img-fluid w-75">
            </div>
        </div>
        <div
            class="col-12 col-lg-7 d-flex flex-wrap justify-content-center align-items-center align-content-center overflow-hidden">
            <!-- <div class="col-12 d-flex justify-content-start sin-imagen">
                <div class="col-xl-11 col-6 d-flex justify-content-end mb-3 "><img :src="a39"
                        class="img-fluid stringImg"></div>
            </div> -->
            <div class="col-12 d-flex justify-content-center text-start align-items-center flex-wrap px-lg-4">
                <span class="font- fuente-posm label-1 d-flex flex-wrap fuentes-clamp">Automatiza tu Facturación<br>
                    <span>y Conciliaciones. </span>
                    <span class="font- label-2  fuente-nova mt-3 ps-3 w-100 fuentes-clamp2">Olvídate de solicitudes por
                        WhatsApp o correos para facturar, Tus clientes emiten sus facturas por sí mismos desde un
                        micrositio personalizado.
                        <br><br>

                        Tu equipo recibe reportes automáticos de conciliación, agilizando auditorías, devoluciones y
                        finanzas.
                    </span>
                </span>
            </div>
            <div class="col-12 d-flex justify-content-start">
                <span class="col-xl-11 d-flex justify-content-end mt-3">
                    <button
                        class="button-outline hover-boton_mod font- fuente-nova2"
                        @click="showModal">
                        Descubre Como
                    </button>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import { openContactModal } from '@/utils/modalHelper'

export default {
    name: 'page1',
    emits: ['sendAction'],
    props: {
        action: {
            type: Object,
            default: () => { }
        }
    },
    watch: {
        action: {
            handler() {
                this.getAction()
            },
            deep: true
        }
    },
    data() {
        return {
            a20: require('@/assets/images/a20.webp'),
            a39: require('@/assets/images/a39.webp')
        }
    },
    methods: {
        makeAction() {
            switch (this.action.type) {
                case '?':
                    break
            }
        },
        showModal() {
            openContactModal();
        }
    },
}
</script>

<style lang="css" scoped>
.cubeSpace {
    overflow: hidden;
    height: auto;
    width: 100vw;
    height: 100vh;
}

.label-1 {
    color: var(--color-2);
    font-size: 65px;
    line-height: 1.1;
    max-width: 900px;
    word-wrap: break-word;
}

.label-2 {
    color: var(--color-3);
    font-size: 29px;
    line-height: 1.1;
}

.stringImg {
    max-width: 300px;
}

@media (max-width: 992px) and (min-width: 768px) {
    .label-1 {
        font-size: 60px;
    }

    .label-2 {
        font-size: 27px;
    }
}

@media (max-width: 767px) and (min-width: 0) {
    .label-1 {
        font-size: 25px;
    }

    .label-2 {
        font-size: 19px;
    }
}
</style>
